import Reveal from "@/components/Reveal";
import { useSeo } from "@/lib/seo";

export default function Confidentialite() {
  useSeo({
    title: "Politique de confidentialité — Gambit Immobilier",
    description:
      "Politique de confidentialité de Gambit Immobilier : traitement des données, cookies, sécurité et exercice des droits.",
    path: "/politique-de-confidentialite",
  });
  return (
    <div data-testid="page-confidentialite" className="bg-cream">
      <section className="mx-auto max-w-[1400px] px-6 pb-12 pt-16 md:px-12 md:pb-16 md:pt-24 lg:px-16">
        <Reveal>
          <p className="kicker mb-8 md:mb-10">Conformité</p>
          <h1 className="text-display text-[clamp(2.25rem,5vw,4rem)] text-ink">
            Politique de <span className="text-gold">confidentialité.</span>
          </h1>
        </Reveal>
      </section>

      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="hairline" />
      </div>

      <section className="mx-auto max-w-[1400px] px-6 py-16 md:px-12 md:py-24 lg:px-16">
        <div className="mx-auto max-w-3xl space-y-14 font-serif text-[1.0625rem] leading-[1.75] text-ink/85 md:text-[1.125rem]">

          <Reveal>
            <p>Le respect de votre vie privée est une priorité pour Gambit Immobilier.</p>
          </Reveal>

          <Reveal>
            <h2 className="kicker mb-4">Responsable du traitement</h2>
            <p>
              Gambit Immobilier<br />
              SASU à capital variable<br />
              Farid Amadet, Président<br />
              552 avenue de la Plage<br />
              40440 Ondres
            </p>
            <p className="mt-4">
              f.amadet@gambit-immo.fr<br />
              07 75 71 39 78
            </p>
          </Reveal>

          <Reveal>
            <h2 className="kicker mb-4">Données collectées</h2>
            <p>Le site est un site vitrine.</p>
            <p className="mt-4">Il ne comporte ni formulaire de contact, ni espace utilisateur.</p>
            <p className="mt-4">Aucune donnée personnelle n'est collectée directement sur le site.</p>
            <p className="mt-4">
              Si vous choisissez de nous contacter par téléphone ou par e-mail,
              les informations que vous transmettez sont utilisées uniquement
              pour répondre à votre demande.
            </p>
          </Reveal>

          <Reveal>
            <h2 className="kicker mb-4">Utilisation des données</h2>
            <p>Les informations communiquées servent exclusivement à échanger avec vous.</p>
            <p className="mt-4">
              Elles ne sont ni vendues, ni cédées, ni utilisées à des fins
              commerciales.
            </p>
          </Reveal>

          <Reveal>
            <h2 className="kicker mb-4">Vos droits</h2>
            <p>
              Vous pouvez demander l'accès, la rectification ou la suppression
              des données vous concernant en écrivant à :
            </p>
            <p className="mt-4">f.amadet@gambit-immo.fr</p>
            <p className="mt-4">
              Vous pouvez également saisir la CNIL si vous estimez que vos
              droits ne sont pas respectés.
            </p>
          </Reveal>

          <Reveal>
            <h2 className="kicker mb-4">Cookies</h2>
            <p>
              Le site n'utilise aucun cookie publicitaire ni de mesure
              d'audience.
            </p>
            <p className="mt-4">
              Seuls les éléments techniques indispensables à son fonctionnement
              peuvent être utilisés.
            </p>
            <p className="mt-4">
              Si cela évolue, cette politique sera mise à jour et, si
              nécessaire, un bandeau de consentement sera mis en place.
            </p>
          </Reveal>

          <Reveal>
            <h2 className="kicker mb-4">Sécurité</h2>
            <p>
              Les mesures appropriées sont mises en œuvre afin de protéger les
              informations échangées contre tout accès, modification ou
              divulgation non autorisés.
            </p>
          </Reveal>

        </div>
      </section>
    </div>
  );
}
